export interface DeleteDedicationDto
{
  
    getAPartyMsisdn(): string;
    getBPartyMsisdn(): string;
    getLanguage(): string;
    getToneId(): string;
    getTimeType(): string;
}

export class DeleteDedicationDtooImpl implements DeleteDedicationDto
{
   
    private aPartyMsisdn: string;
    private bPartyMsisdn: string;
    private language: string;
    private toneId: string;
    private timeType: string;
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    } 
    setBPartyMsisdn(bPartyMsisdn: string)
    {
        this.bPartyMsisdn = bPartyMsisdn;
    }
    getBPartyMsisdn(): string 
    {
        return this.bPartyMsisdn;
    } 
    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    setTimeType(timeType: string)
    {
        this.timeType = timeType;
    }

    getTimeType(): string {
        return this.timeType;
    }


    setToneId(toneId: string)
    {
        this.toneId = toneId;
    }
    getToneId(): string 
    {
        return this.toneId;
    } 

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/deletededication/deletededicationdto.ts